/**
 * Client-side deploy config injected by the server into the SSR shell (NM-188).
 *
 * In a split-origin deploy the SPA is served from the frontend origin
 * (`www.beta.newsmonger.app`) but the API and auth live on another
 * (`api.beta.newsmonger.app`), so every `/api` + `/auth` call must be prefixed
 * with that origin. The server stamps it into a `<meta name="newsmonger-api-base">`;
 * same-origin builds (local dev) omit it, so the base is empty and calls stay
 * relative — unchanged.
 */

let cached: string | null = null;

/** The API/auth origin to prefix calls with, or `''` for same-origin. Read once. */
export function apiBase(): string {
  if (cached !== null) return cached;
  const meta = typeof document !== 'undefined' ? document.querySelector('meta[name="newsmonger-api-base"]') : null;
  cached = meta?.getAttribute('content') ?? '';
  return cached;
}
